import { encrypt } from "../../utility/v2.0/encryptionServiceV2";

//Action creator with callback function
export function addUserDetail(userDetails) {
  return async (dispatch) => {
    const [
      encryptCustomerID,
      encryptedEmail,
      encryptedMobileNumber,
      encryptedAddressLine1,
      encryptedAddressLine2,
      encryptedUserSessionID,
      encryptedBirthday,
      encryptedContactNumber,
    ] = await Promise.all([
      encrypt(userDetails.customerID),
      encrypt(userDetails.email),
      encrypt(userDetails.mobileNumber),
      encrypt(userDetails.addressLine1),
      encrypt(userDetails.addressLine2),
      encrypt(userDetails.userSessionID),
      encrypt(userDetails?.birthday),
      encrypt(userDetails?.contactNumber),
    ]);
    userDetails.customerID = encryptCustomerID;
    userDetails.email = encryptedEmail;
    userDetails.mobileNumber = encryptedMobileNumber;
    userDetails.addressLine1 = encryptedAddressLine1;
    userDetails.addressLine2 = encryptedAddressLine2;
    userDetails.userSessionID = encryptedUserSessionID;
    userDetails.birthday = encryptedBirthday;
    userDetails.contactNumber = encryptedContactNumber;
    dispatch({
      type: "ADD_USER_DETAIL",
      payload: userDetails,
    });
    return true;
  };
}

export const updateIsTemporaryCart = (isTemporaryCart) => ({
  type: "UPDATE_IS_TEMPORARY_CART",
  payload: isTemporaryCart,
});

export function updateIsFirstLogin(isFirstLogin) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: "UPDATE_IS_FIRST_LOGIN",
        payload: isFirstLogin,
      });
      resolve(true);
    });
  };
}

export function updateIsNexusFlag(isNexus) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: "UPDATE_IS_NEXUS_FLAG",
        payload: isNexus,
      });
      resolve(true);
    });
  };
}

export const  AddNexusId = (nexusId)=> ({
  type: "ADD_NEXUS_ID",
  payload: nexusId
})

export function updateAddress(addressDetails) {
  return async (dispatch) => {
    const [encryptedAddressLine1, encryptedAddressLine2] = await Promise.all([
      encrypt(addressDetails.addressLine1),
      encrypt(addressDetails.addressLine2),
    ]);
    addressDetails.addressLine1 = encryptedAddressLine1;
    addressDetails.addressLine2 = encryptedAddressLine2;
    dispatch({
      type: "UPDATE_ADDRESS",
      payload: addressDetails,
    });
    return true;
  };
}

export function updateRefundOption(refundOptionID) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: "UPDATE_REFUND_OPTION",
        payload: refundOptionID,
      });
      resolve(true);
    });
  };
}

export const resetUserDetail = () => ({
  type: "RESET_USER_DETAIL",
});

export function updateIsHasNotificationFlag(userDetails) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: "UPDATE_HAS_NOTIFICATION_FLAG",
        payload: userDetails,
      });
      resolve(true);
    });
  };
}

export function updateIsCompleteAddress(isComplete) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: "UPDATE_ISADDRESSCOMPLETED",
        payload: isComplete,
      });
      resolve(true);
    });
  };
}

export function updateIsFirstLoginAfterPremium(isFirstLoginAfterPremium) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: "UPDATE_IS_FIRST_LOGIN_AFTER_PREMIUM",
        payload: isFirstLoginAfterPremium,
      });
      resolve(true);
    });
  };
}

export function updateAddressDetails(addressDetails) {
  return async (dispatch) => {
    const [encryptedAddressLine1, encryptedAddressLine2] = await Promise.all([
      encrypt(addressDetails.addressLine1),
      encrypt(addressDetails.addressLine2),
    ]);
    addressDetails.addressLine1 = encryptedAddressLine1;
    addressDetails.addressLine2 = encryptedAddressLine2;
    dispatch({
      type: "UPDATE_ADDRESSDETAILS",
      payload: addressDetails,
    });
    return true;
  };
}
